const pageBackground = {
  minHeight: '100vh',
  background: '#f5f7fb',
  padding: '3rem 2rem',
  color: '#0f172a',
};

export default function Home() {
  return (
    <div style={pageBackground}>
      <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
        <h1 style={{ fontWeight: 700, marginBottom: '0.5rem' }}>Welcome to TrackIT</h1>
        <p style={{ color: '#cbd5e1', maxWidth: '38rem', marginBottom: '1.25rem' }}>
          Your finance cockpit is ready - jump into dashboards, users, and categories with the unified neon glass theme.
        </p>
      </div>
    </div>
  );
}
